module.exports = __webpack_public_path__ + "img/lg_ring_g_s_1_0@3x.901e7161.png";